import { Link } from "react-router-dom";
import './footer.scss'
import logo from '../../images/logo2.png'
import {
  BiLogoFacebook,
  BiLogoInstagram,
  BiLogoLinkedin,
} from "react-icons/bi";

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-top">
        <div className="logo">
          <Link to="/" className="link">
            <img src={logo} alt="Logo" className="footer-logo" />
          </Link>
        </div>
        
        <div className="social-media-icons-wrapper">
          <a
            href="https://www.instagram.com/mantraflex_wellness?igsh=MWVrbzhlYm5zY3N2aw=="
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
          >
            <BiLogoInstagram className="social-media-icon" />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
          >
            <BiLogoFacebook className="social-media-icon" />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
          >
            <BiLogoLinkedin className="social-media-icon" />
          </a>
        </div>
        <div className="footer-contact-info">
          <a href="mailto:mantraflexwellness@gmail.com" className="contact">
            Email: mantraflexwellness@gmail.com
          </a>
          <a href="tel:+16472124483" className="contact">
            Tel: 613-979-2402
          </a>
          <p className="hours-operation">Mon - Fri: 9am to 7pm</p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="link-categories">
          <Link to="/" className="link">HOME</Link>
          <Link to="/services" className="link">SERVICES</Link>
          <Link to="/faq" className="link">FAQ</Link>
          <Link to="/location" className="link">LOCATION</Link>
          <Link to="/contact" className="link">CONTACT US</Link>
        </div>
      </div>
      <p className="copyright">
        Copyright &copy; {new Date().getFullYear()} Mantraflex Inc.
      </p>
    </footer>

  );
}

export default Footer;
